var $6e87462e84907983$exports = {};
$6e87462e84907983$exports = {
  "buttonLabel": "\u5019\u88DC\u3092\u8868\u793A",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
      }
    }), "\u3092\u5229\u7528\u3067\u304D\u307E\u3059\u3002");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u5165\u529B\u3055\u308C\u305F\u30B0\u30EB\u30FC\u30D7 ".concat(args.groupTitle, "\u3001").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
          }
        }), "\u3092\u542B\u3080\u3002");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: "\u3001\u9078\u629E\u6E08\u307F",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u5019\u88DC",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, "\u3001\u9078\u629E\u6E08\u307F");
  }
};
export { $6e87462e84907983$exports as default };